/**
 * Converts a number of minutes into milliseconds.
 * @param m - The number of minutes.
 * @returns The equivalent number of milliseconds.
 */
export const minutesToMilliseconds = (m: number): number => m * 60 * 1000;

/**
 * Converts a number of days into milliseconds.
 * @param d - The number of days.
 * @returns The equivalent number of milliseconds.
 */
export const daysToMilliseconds = (d: number): number => d * 24 * 60 * 60 * 1000;